import { PaymentRequestReason, PaymentRequestType } from '@mews-commander/data-access';
import { LocalizedText, LocalizedEnum, useFeatureFlag } from '@mews/framework';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { Dash } from '@mews-commander/ui';

interface PaymentRequestsTableReasonCellProps {
    type: PaymentRequestType;
    reason: PaymentRequestReason;
}

export const PaymentRequestsTableReasonCell = ({ type, reason }: PaymentRequestsTableReasonCellProps) => {
    const isPaymentRequestCollectTypeEnabled = useFeatureFlag(FeatureFlag.paymentRequestCollectTypeEnabled);

    if (isPaymentRequestCollectTypeEnabled) {
        switch (type) {
            case PaymentRequestType.Payment: {
                return <LocalizedEnum prefix="PaymentRequestReason" value={reason} />;
            }
            case PaymentRequestType.Preauthorization: {
                return <LocalizedText textKey={TextKey.PaymentRequestsTableReasonPreauthorizePayment} />;
            }
            case PaymentRequestType.PaymentMethod: {
                return <LocalizedText textKey={TextKey.PaymentRequestsTableReasonCollectPaymentMethod} />;
            }
            default:
                return <Dash />;
        }
    }

    return <LocalizedEnum prefix="PaymentRequestReason" value={reason} />;
};
